import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { config } from 'sanitize-text/sanitizers/SanitizeConfiguration';
import { openLinksInNewTab } from 'sanitize-text/transformers/openLinksInNewTab';

/*
 * Renders sanitized catalog HTML (e.g. merch-card feature descriptions).
 *
 * Deliberately uses sanitize-text's low-level `sanitize()` rather than the
 * `SanitizedText` component / `formatHtml`, which statically import
 * `autolinker` (~188 KB) to turn BARE urls into links. Our catalog copy never
 * contains bare urls — links are rendered as React components — so autolinking
 * is pure dead weight, and it was the largest single module in the public entry
 * chunk. `sanitize()` still XSS-sanitizes the HTML and, via its default
 * transformers plus `openLinksInNewTab`, keeps any explicit <a> tags safe and
 * opening in a new tab (matching the previous shouldOpenLinksInNewTab: true).
 *
 * See pricing-pages-ui-public-app/docs/bundle-optimization-tasks.md (Ticket 1).
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const SanitizedHtmlText = ({
  body
}) => {
  if (!body) {
    return null;
  }
  const html = sanitize(body, config.HTML, [openLinksInNewTab]);
  if (!html) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    dangerouslySetInnerHTML: {
      __html: html
    }
  });
};